module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-it-IT.ba949c33.jpg";